import React from 'react'
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import NotVideoImg2 from '../../../assets/img/jobs/VideoSoon2560.jpg';
import VideoIcon from '../../../assets/icons/job/VideoIcon';
import s from './VideoSlideItem.module.scss';



const VideoSlideItem = ({ isVideo, videoSrc, poster, title }) => {
  return (
    <article className={s.slide}>
      {isVideo 
        ? <VideoPlayer 
            src={videoSrc} 
            poster={poster} 
            title={title}
          /> 
        : <div className={s.nonVideoContent}>
            <div className={s.notVideoImgWrapper}>
              <div className={s.bgBlackWhite}></div>
              <img className={s.notVideoImg} alt="video soon" src={NotVideoImg2}/>
              <div className={s.icon}>
                <VideoIcon />
              </div>
              <p className={s.text}>Видео скоро</p>
            </div>
          </div>
      }
    </article>
  );
}

export default VideoSlideItem;